import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  @Input() loaderWidth?: any;
  @Input() loaderWidthRem?: any;
  @Input() loaderHeight?: any;
  @Input() loaderType: string;
  @Input() loaderRadius?: string;
  @Input() marginTop?: string;
  @Input() marginLeft?: string;
  @Input() marginRight?: string;
  @Input() marginBottom?: string;
  @Input() padding?: string;

  constructor() { }

  ngOnInit() {
  }

}
